<template>
  <div class="">
    <br />
    <h2 class="text-md-center text-lg-center text-sm-center earth-color">
      SUPPORT US
    </h2>
    <v-container>
      <v-card flat>
        <v-container fluid>
          <v-form
            @submit.prevent="supportUs()"
            ref="form"
            v-model="valid"
            lazy-validation
          >
            <v-layout row wrap>
              <v-flex lg6 md6 sm12 xs12>
                <v-container>
                  <v-autocomplete
                    label="Donate to"
                    v-model="donation.payment_option"
                    :items="allCauses"
                    :rules="[v => !!v || 'Place to donate to is required']"
                    required
                    item-text="name"
                    item-value="public_id"
                    :loading="$loadingTrue"
                  ></v-autocomplete>
                </v-container>
              </v-flex>
              <v-flex lg6 md6 sm12 xs12
                ><v-container>
                  <v-autocomplete
                    label="Payment Method"
                    v-model="donation.payment_method"
                    :items="allPaymentMethods"
                    :rules="[v => !!v || 'Payment method is required']"
                    required
                    item-text="name"
                    item-value="public_id"
                    :loading="$loadingTrue"
                  ></v-autocomplete> </v-container
              ></v-flex>
              <v-flex lg6 md6 sm12 xs12
                ><v-container>
                  <v-autocomplete
                    label="Currency"
                    v-model="donation.currency"
                    :items="allCurrencies"
                    :rules="[v => !!v || 'Payment method is required']"
                    required
                    item-text="currency_name"
                    item-value="currency_public_id"
                    :loading="$loadingTrue"
                  ></v-autocomplete> </v-container
              ></v-flex>
              <v-flex lg6 md6 sm12 xs12
                ><v-container>
                  <v-text-field
                    v-model="donation.amount"
                    :rules="requiredRules"
                    label="Donation Amount"
                    required
                    type="number"
                    min="1"
                  ></v-text-field> </v-container
              ></v-flex>
              <v-flex lg6 md6 sm12 xs12>
                <v-container>
                  <v-autocomplete
                    label="Frequency"
                    v-model="donation.frequency"
                    :items="allFrequency"
                    :rules="[v => !!v || 'Country is required']"
                    required
                    item-text="name"
                    item-value="public_id"
                    :loading="$loadingTrue"
                  ></v-autocomplete>
                </v-container>
              </v-flex>
              <v-flex lg6 md6 sm12 xs12
                ><v-container>
                  <v-autocomplete
                    label="Title"
                    v-model="donation.title"
                    :items="['Mr.', 'Mrs.', 'Ms.', 'Dr.', 'Eng.', 'Prof.']"
                    :rules="[v => !!v || 'Title method is required']"
                    required
                    :loading="$loadingTrue"
                  ></v-autocomplete> </v-container
              ></v-flex>
              <v-flex lg6 md6 sm12 xs12
                ><v-container>
                  <v-text-field
                    v-model="donation.first_name"
                    :rules="requiredRules"
                    label="First Name"
                    required
                    max-length="20"
                  ></v-text-field> </v-container
              ></v-flex>
              <v-flex lg6 md6 sm12 xs12
                ><v-container>
                  <v-text-field
                    v-model="donation.sur_name"
                    :rules="requiredRules"
                    label="Last Name"
                    required
                    max-length="20"
                  ></v-text-field> </v-container
              ></v-flex>
              <v-flex lg6 md6 sm12 xs12
                ><v-container>
                  <v-text-field
                    v-model="donation.email"
                    :rules="requiredRules"
                    label="Email"
                    required
                    type="email"
                  ></v-text-field> </v-container
              ></v-flex>
              <v-flex lg6 md6 sm12 xs12>
                <v-container>
                  <v-autocomplete
                    label="Country"
                    @change="findCountryCode"
                    v-model="donation.country"
                    :items="allCountries"
                    :rules="[v => !!v || 'Country is required']"
                    required
                    item-text="name"
                    item-value="code"
                    :loading="$loadingTrue"
                  ></v-autocomplete>
                </v-container>
              </v-flex>
              <v-flex lg6 md6 sm12 xs12>
                <v-container>
                  <v-text-field
                    v-model="donation.phone_number"
                    :rules="requiredRules"
                    label="Phone Number (e.g. +XXX...)"
                    required
                    minlength="13"
                  ></v-text-field> </v-container
              ></v-flex>
              <v-flex lg6 md6 sm12 xs12>
                <v-container>
                  <v-text-field
                    v-model="donation.city"
                    label="City"
                    required
                    :rules="requiredRules"
                    max-length="30"
                  ></v-text-field>
                </v-container>
              </v-flex>
              <v-flex lg6 md6 sm12 xs12
                ><v-container>
                  <v-select
                    label="Gender"
                    v-model="donation.gender"
                    :items="['Male', 'Female']"
                    :rules="[v => !!v || 'Country is required']"
                    required
                  ></v-select> </v-container
              ></v-flex>
              <v-flex lg6 md6 sm12 xs12
                ><v-container>
                  <v-dialog
                    ref="dialog"
                    persistent
                    v-model="modal1"
                    lazy
                    full-width
                    width="290px"
                    :return-value.sync="donation.dob"
                  >
                    <v-text-field
                      slot="activator"
                      label="Date of Birth"
                      v-model="donation.dob"
                      :rules="requiredRules"
                      readonly
                    ></v-text-field>
                    <v-date-picker v-model="donation.dob" scrollable>
                      <v-spacer></v-spacer>
                      <v-btn
                        :depressed="true"
                        flat
                        color="primary"
                        @click="modal1 = false"
                        >Cancel</v-btn
                      >
                      <v-btn
                        :depressed="true"
                        flat
                        color="primary"
                        @click="$refs.dialog.save(donation.dob)"
                        >OK</v-btn
                      >
                    </v-date-picker>
                  </v-dialog>
                </v-container></v-flex
              >
              <v-flex lg6 md6 sm12 xs12
                ><v-container>
                  <h5 class="earth-color">Contact Preferences</h5>
                  <p style="font-size: 17px">
                    We regularly send out information and exciting updates on
                    our work and ways you can support us. If you are interested
                    in receiving this, please let us know how you'd like ud to
                    contact you:
                  </p>

                  <input
                    type="checkbox"
                    id="email"
                    value="email"
                    class="ml-auto"
                    v-model="donation.preference"
                  />
                  <label class="ml-1" for="email">Email</label>
                  <br />

                  <input
                    type="checkbox"
                    id="phone"
                    value="phone"
                    v-model="donation.preference"
                  />
                  <label class="ml-1" for="phone">Phone</label>
                  <br />

                  <input
                    type="checkbox"
                    id="sms"
                    value="sms"
                    v-model="donation.preference"
                  />
                  <label class="ml-1" for="sms">SMS</label>
                  <br />
                  <input
                    type="checkbox"
                    id="post"
                    value="post"
                    v-model="donation.preference"
                  />

                  <label class="ml-1" for="not_interested">Post</label>
                </v-container></v-flex
              >
              <v-flex lg12 md12 sm12 xs12
                ><v-container>
                  <h5 class="earth-color">Feedback</h5>
                  <p style="font-size: 17px">
                    We love to hear from our supporters.Please tell us what
                    prompted you to donate to us today:
                  </p>
                  <vue-editor
                    v-model="donation.feedback"
                  ></vue-editor> </v-container
              ></v-flex>
              <v-flex lg6 md6 sm12 xs12
                ><v-container>
                  <v-btn
                    :depressed="true"
                    type="submit"
                    color="primary"
                    style="float: right"
                    >Proceed to Donation Payment</v-btn
                  >
                </v-container></v-flex
              >
            </v-layout>
          </v-form>
        </v-container>
      </v-card>
    </v-container>
    <h4 class="text-md-center text-lg-center text-sm-center earth-color">
      ACCEPTED MODES OF PAYMENT
    </h4>
    <v-container>
      <v-layout row wrap align-center>
        <v-flex lg2 md2 sm2 xs2></v-flex>
        <v-flex lg2 md2 sm2 xs2>
          <img
            src="@/assets/Public/payments/Mastercard.jpg"
            width="100%"
            alt=""
          />
        </v-flex>
        <v-flex lg2 md2 sm2 xs2>
          <img src="@/assets/Public/payments/visa.png" width="100%" alt="" />
        </v-flex>
        <v-flex lg2 md2 sm2 xs2>
          <img
            src="@/assets/Public/payments/bank_transfer.svg"
            width="70%"
            alt=""
          />
        </v-flex>
        <v-flex lg2 md2 sm2 xs2>
          <img src="@/assets/Public/payments/mpesa.png" width="70%" alt="" />
        </v-flex>
        <v-flex lg2 md2 sm2 xs2></v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { VueEditor } from "vue2-editor";
export default {
  data() {
    return {
      requiredRules: [v => !!v || "This field is required"],
      emailRules: [
        v => !!v || "E-mail is required",
        v => /.+@.+/.test(v) || "E-mail must be valid"
      ],
      valid: true,
      menu1: false,
      modal1: false,
      dob_config: {
        minDate: "today"
      },
      country: "",
      anonymity: false,
      donation: {
        anonymity: "",
        frequency: "",
        payment_option: "",
        payment_method: "",
        amount: "",
        title: "",
        first_name: "",
        sur_name: "",
        phone_number: "",
        country: "",
        city: "",
        gender: "",
        dob: "",
        currency: "",
        feedback: "",
        preference: []
      }
    };
  },
  computed: {
    notifications() {
      this.assignNotifications();
      return null;
    }
  },
  methods: {
    findCountryCode(data) {
      var instance = this;
      this.allCountries.map(function(country) {
        if (data === country.code) {
          instance.donation.phone_number = "+" + country.calling_code;
        }
      });
    },
    assignNotifications() {
      this.donation.anonymity = this.allAnonimity[0].public_id;
    },
    changeAnonymity: function() {
      if (this.donation.anonymity === " jk4545") {
        this.anonymity = true;
      }
    },
    supportUs: function() {
      // this.donation.country = this.country.name
      if (this.$refs.form.validate()) {
        
        this.$store.dispatch("post_public_donation", this.donation);
      }
    }
  },
  created() {
    this.$store.dispatch("get_all_currencies");
    this.$store.dispatch("get_all_countries");
    this.$store.dispatch("get_all_anonymity");
    this.$store.dispatch("get_all_frequency");
    this.$store.dispatch("get_all_donation_payment_methods");
    this.$store.dispatch("get_all_causes");
  },
  components: {
    VueEditor
  }
};
</script>

<style>
li {
  text-decoration: none;
  list-style: none;
}
</style>
